var map = {
	"./brands.js": [
		10,
		9,
		0,
		4
	],
	"./loader.js": [
		11,
		7,
		5
	],
	"./tabs.js": [
		12,
		9,
		8,
		6
	],
	"./testimonials.js": [
		13,
		9,
		0,
		7
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 7;
module.exports = webpackAsyncContext;